//:: AUTH
export const AUTH_SET_USER_ID = "AUTH_SET_USER_ID";
export const AUTH_SET_EMAIL = "AUTH_SET_EMAIL";
export const AUTH_SET_ROLES = "AUTH_SET_ROLES";
export const AUTH_SET_PERMISSIONS = "AUTH_SET_PERMISSIONS";
export const AUTH_SET_ACCESS_TOKEN = "AUTH_SET_ACCESS_TOKEN";
export const AUTH_SET_ACCESS_TOKEN_DATE = "AUTH_SET_ACCESS_TOKEN_DATE";
export const AUTH_SET_ACCESS_SESSION = "AUTH_SET_ACCESS_SESSION";
export const AUTH_SET_REFRESH_TOKEN = "AUTH_SET_REFRESH_TOKEN";
export const AUTH_SET_REFRESHING = "AUTH_SET_REFRESHING";
export const AUTH_SET_STAFF_ID = "AUTH_SET_STAFF_ID";
export const AUTH_SET_STAFF_NAME = "AUTH_SET_STAFF_NAME";
export const AUTH_SET_STATUS = "AUTH_SET_STATUS";
export const AUTH_SET_ERROR = "AUTH_SET_ERROR";
export const AUTH_RESET = "AUTH_RESET";

//:: MODELS & COLLECTIONS
export const PROJECT__SET = "PROJECT__SET";
export const PROJECT__SET_NAME = "PROJECT__SET_NAME";
export const SUBMISSION__SET = "SUBMISSION__SET";
export const SUBMISSION__SET_NAME = "SUBMISSION__SET_NAME";
export const SAMPLE__SET = "SAMPLE__SET";
export const SAMPLE__SET_NAME = "SAMPLE__SET_NAME";

// Lab Context
export const LAB_CONTEXT_SET_LABORATORY = "LAB_CONTEXT_SET_LABORATORY";

//:: Breadcrumbs
export const BREADCRUMB_SET_NAME = "BREADCRUMB_SET_NAME";

//:: Overlay
export const OVERLAY_SHOWN = "OVERLAY_SHOWN";

//:: Trash
export const ADD_TO_TRASH = "ADD_TO_TRASH";
export const REMOVE_FROM_TRASH = "REMOVE_FROM_TRASH";
export const REMOVE_ALL_FROM_TRASH = "REMOVE_ALL_FROM_TRASH";

//:: Project form
export const STEP_ONE_UPDATE = "STEP_ONE_UPDATE";
export const ADD_SUBMISSION = "ADD_SUBMISSION";
export const SUBMISSION_UPDATE = "SUBMISSION_UPDATE";
export const SUBMISSION_DELETE = "SUBMISSION_DELETE";
export const SAMPLE_TYPE_SET = "SAMPLE_TYPE_SET";
export const TEST_PACKAGE_GROUPS_SET = "TEST_PACKAGE_GROUPS_SET";
export const SERVICE_QUESTIONS_SET = "SERVICE_QUESTIONS_SET";
export const TURNAROUNDS_SET = "TURNAROUNDS_SET";
export const FORM_STATUS_UPDATE = "FORM_STATUS_UPDATE";
export const SUBMISSION_SAMPLE_UPDATE = "SUBMISSION_SAMPLE_UPDATE";
export const STORE_RESET = "STORE_RESET";

//:: Attribute Form
export const PARENT_ID_UPDATE = "PARENT_ID_UPDATE";
export const ACCESS_MESSAGE_TOGGLE = "ACCESS_MESSAGE_TOGGLE";

//:: Receive store
export const ADD_TO_RECEIVE = "ADD_TO_RECEIVE";
export const REMOVE_FROM_RECEIVE = "REMOVE_FROM_RECEIVE";
export const REMOVE_ALL_FROM_RECEIVE = "REMOVE_ALL_FROM_RECEIVE";

//:: Schedule store
export const SCHEDULE_FORM_RESET = "SCHEDULE_FORM_RESET";
export const SELECTED_DATE_SET = "SELECTED_DATE_SET";
export const SCHEDULE_FORM_UPDATE = "SCHEDULE_FORM_UPDATE";
export const SCHEDULE_SAMPLE_LIST_UPDATE = "SCHEDULE_SAMPLE_LIST_UPDATE";
